





























import { Component, Vue, Watch } from 'vue-property-decorator';
import { getModule } from 'vuex-module-decorators';
import store from '@/store/store';
import Auth from '@/store/modules/auth';
import { db } from '@/plugins/firebase';
import { levelTable } from '@/plugins/levelTable';
import { User, auth } from 'firebase';
const authModule = getModule(Auth, store);

@Component
export default class PersonalHistory extends Vue {
  editing = [];
  edited = [];

  get user() {
    return authModule.user;
  }

  mounted() {
    const editingQuery = db
      .collection('personalHistory')
      .where('uid', '==', authModule.user.uid)
      .where('editing', '==', true)
      .orderBy('timestamp', 'desc')
      .limit(5);
    const editedQuery = db
      .collection('personalHistory')
      .where('uid', '==', authModule.user.uid)
      .where('editing', '==', false)
      .orderBy('timestamp', 'desc')
      .limit(5);
    this.$bind('editing', editingQuery);
    this.$bind('edited', editedQuery);
  }
}
